import type { UseFormRegisterReturn } from 'react-hook-form';

/**
 * Spam trap: a field humans never see or reach. Kept in the DOM (NOT
 * display:none — some bots skip hidden inputs) but moved off-screen, removed
 * from the tab order and hidden from assistive tech. The server answers a
 * filled honeypot with the same answer as a real submission.
 *
 *   <Honeypot field={register('website')} />
 */
export function Honeypot({ field }: { field: UseFormRegisterReturn }) {
  return (
    <div aria-hidden="true" className="absolute -left-[10000px] top-auto w-px h-px overflow-hidden">
      {/* Label avoids "Website"/"URL" wording so browser autofill never fills it
          (a filled honeypot silently drops a real submission). */}
      <label>
        Leave this field empty
        <input type="text" tabIndex={-1} autoComplete="off" data-1p-ignore data-lpignore="true" {...field} />
      </label>
    </div>
  );
}
